import AppCardsList from './AppCardsList.vue';

export * from './types';
export * from './consts';
export default AppCardsList;



// WEBPACK FOOTER //
// ./src/uikit/components/AppCardsList/index.ts